import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { workProcess } from '../../data/mock';
import StarburstDecor from '../ui/StarburstDecor';

const WorkProcessSection = () => {
  return (
    <section className="bg-white py-16">
      <div className="container-main">
        <div className="flex items-start justify-between mb-10">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy font-display">
              Creative<br />Work Process
            </h2>
          </div>
          <StarburstDecor size={80} color="lime" className="hidden md:block" />
        </div>

        <div className="space-y-0">
          {workProcess.map((step, index) => (
            <div
              key={step.id}
              className="flex items-center justify-between py-5 border-b border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer group"
            >
              <h3 className="text-lg font-semibold text-navy">{step.title}</h3>
              <div className="flex items-center gap-4">
                <p className="hidden lg:block text-gray-500 text-sm max-w-md">
                  {step.description}
                </p>
                <button className="flex items-center gap-2 text-sm font-medium text-navy">
                  Details
                  <span className="w-8 h-8 bg-lime rounded-full flex items-center justify-center group-hover:bg-lime/80 transition-colors">
                    <ArrowUpRight className="w-4 h-4 text-navy" />
                  </span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkProcessSection;
